<template>
  <div class="payment-widget">
    <transition name="fade">
      <div class="payment-overlay" @click.self="closeModal">
        <div class="modal-widget">
          <iframe v-if="iframeUrl" :src="iframeUrl" frameborder="0" width="100%" height="100%"></iframe>
          <loading v-if="loading" :height="50" color="#9fc953" :opacity="1" :width="50" :active.sync="loading"
            :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader">
          </loading>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
export default {
  name: "payment-widget",
  components: {},
  props: {
    amount: {
      type: [String, Number],
    },
    currency: {
      type: String,
      default: "RWF",
    },
    payload: {
      type: Object,
      default: null,
    },
    url: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      iframeUrl: "",
    };
  },
  destroyed() { },
  watch: {
  },
  mounted() {
    let vm = this;
    let form_temp = {
      ...vm.payload,
      url: vm.url,
      amount: vm.amount,
      currency: vm.currency,
      first_name: null,
      last_name: null,
      email: null,
      phone_number: null
    };
    if (vm.$getLoggedUser()) {
      let user = vm.$getLoggedUser().user;
      form_temp.phone_number = user.phone;
      form_temp.first_name = user.first_name;
      form_temp.last_name = user.last_name;
      form_temp.email = user.email;
    }
    vm.initEvent();
    vm.initiatePayment(form_temp);
  },
  methods: {
    initiatePayment(form) {
      let vm = this;
      vm.loading = true;
      vm.$store
        .dispatch("INITIATE_PAYMENT", form)
        .then((response) => {
          vm.$emit("initial", {
            token: response.data.requestToken,
          });
          vm.iframeUrl = response.data.iframeUrl;
        })
        .catch(({ response }) => {
          vm.loading = false;
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    initEvent() {
      let vm = this;
      window.addEventListener(
        "message",
        (event) => {
          if (event.data && event.data.type === 'PAYMENT_STATUS') {
            const status = event.data.status;
            switch (status) {
              case 'init':
                vm.loading = false;
                break;
              case 'success':
                vm.$emit("success", { status: "ok" });
                break;
              case "failed":
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: "Payment failed, Try again with another payment method",
                });
                vm.$emit("back", null);
                break;
              case "close":
                vm.$emit("back", null);
                break;
            }
          }
        },
        false
      );
    },
    closeModal() {
      this.$emit("close", null);
    }
  },
};
</script>



<style lang="scss" scoped>
.payment-widget {
  .payment-overlay {
    position: fixed !important;
    left: 0px;
    bottom: 0px;
    right: 0px;
    top: 0px;
    z-index: 9999999999;
    display: flex;
    background-color: rgba($color: #000000, $alpha: 0.8);
    padding-top: 80px;
    padding-bottom: 30px;

    .modal-widget {
      margin: 0 auto;
      width: 500px;
      height: 100%;
      background: #fff;
      border-radius: 15px;
      overflow: hidden;
      position: relative;
      padding: 4px 0px;

      @media screen and (max-width: 500px) {
        width: 100%;
        position: fixed;
        z-index: 999999999999999;
        top: 0px;
        left: 0px;
        bottom: 0px;
        right: 0px;
        height: auto;
        display: flex;
        flex-direction: column;
      }
    }
  }
}
</style>
